<template>
  <div class="grid row">
    <div class="flex xs12">
      <va-card title="Edit Certificate" class="fill-height">
        <div>
          <div class="row">
            <div class="flex xs12">
              <va-input
                label="Name *"
                v-model="name"
                :messages="['Certificate name']"
                @input="delete errors.name"
                :error="!!errors.name"
                :error-messages="errors.name"
              />

              <va-card class="mb-3" title="File UA (PDF)">
                <div v-if="fileUkExisting">
                  <a style="display: block; margin-bottom: 8px;" target="_blank" :href="fileUkExisting">
                    <p>{{ fileUkExisting }}</p>
                  </a>
                  <va-button small color="danger" @click="fileUkExisting = ''; newFileUk = null">Видалити</va-button>
                </div>
                <span>Завантажити PDF (українська версія)</span>
                <va-file-upload
                  dropzone
                  v-model="fileUk"
                  style="margin-bottom: 25px;"
                />
                <va-button @click="uploadFile(fileUk[0], 'uk')">Завантажити</va-button>
              </va-card>

              <va-card class="mb-3" title="File EN (PDF)">
                <div v-if="fileEnExisting">
                  <a style="display: block; margin-bottom: 8px;" target="_blank" :href="fileEnExisting">
                    <p>{{ fileEnExisting }}</p>
                  </a>
                  <va-button small color="danger" @click="fileEnExisting = ''; newFileEn = null">Видалити</va-button>
                </div>
                <span>Завантажити PDF (англійська версія)</span>
                <va-file-upload
                  dropzone
                  v-model="fileEn"
                  style="margin-bottom: 25px;"
                />
                <va-button @click="uploadFile(fileEn[0], 'en')">Завантажити</va-button>
              </va-card>

              <va-toggle label="Published" small v-model="published"/>
              <va-button @click="submit()">Save</va-button>
            </div>
          </div>
        </div>
      </va-card>
    </div>
  </div>
</template>

<script>
import * as axios from 'axios'
import Vue from 'vue'

export default {
  name: 'grid',
  data () {
    return {
      name: '',
      published: false,

      fileUk: [],
      newFileUk: null,
      fileUkExisting: '',

      fileEn: [],
      newFileEn: null,
      fileEnExisting: '',

      errors: [],
    }
  },
  created () {
    this.fetch()
  },
  methods: {
    submit () {
      const data = {
        name: this.name,
        file_uk: this.newFileUk,
        file_en: this.newFileEn,
        published: !!this.published,
      }

      if (this.$route.params.id) {
        axios.put(`${process.env.VUE_APP_BGK_API_URL}/${this.locale}/admin/certificates/${this.$route.params.id}`, data)
          .then(() => {
            this.showToast('Success')
          })
          .catch(error => {
            if (error.response.status === 422) {
              this.errors = error.response.data.errors
            }
            console.log(error)
            this.showToast('Error')
          })
      } else {
        axios.post(`${process.env.VUE_APP_BGK_API_URL}/${this.locale}/admin/certificates`, data)
          .then(() => {
            this.$router.push({ name: 'bgk-page-certificates' })
            this.showToast('Success')
          })
          .catch(error => {
            if (error.response.status === 422) {
              this.errors = error.response.data.errors
            }
            console.log(error)
            this.showToast('Error')
          })
      }
    },
    fetch () {
      if (this.$route.params.id) {
        axios.get(`${process.env.VUE_APP_BGK_API_URL}/${this.locale}/admin/certificates/${this.$route.params.id}`)
          .then(response => {
            this.name = response.data.name
            this.published = !!response.data.published
            this.newFileUk = response.data.file_uk
            this.newFileEn = response.data.file_en
            this.fileUkExisting = response.data.file_uk
              ? `${process.env.VUE_APP_BGK_URL}${response.data.file_uk}`
              : ''
            this.fileEnExisting = response.data.file_en
              ? `${process.env.VUE_APP_BGK_URL}${response.data.file_en}`
              : ''
          })
          .catch(error => {
            console.log(error)
            this.showToast('Error')
            this.$router.push({ name: 'bgk-page-certificates' })
          })
      }
    },
    uploadFile (file, lang) {
      if (!file) return
      const formData = new FormData()
      formData.append('file', file)
      axios.post(`${process.env.VUE_APP_BGK_API_URL}/${this.locale}/admin/media`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
        .then(response => {
          if (lang === 'uk') {
            this.newFileUk = response.data.patch
            this.fileUkExisting = `${process.env.VUE_APP_BGK_URL}${response.data.patch}`
          } else {
            this.newFileEn = response.data.patch
            this.fileEnExisting = `${process.env.VUE_APP_BGK_URL}${response.data.patch}`
          }
          this.showToast('Successful upload')
        })
        .catch(error => {
          console.log(error)
          this.showToast('Error')
        })
    },
  },
  computed: {
    locale () {
      return Vue.i18n.locale()
    },
  },
  watch: {
    locale (value) {
      this.fetch()
    },
  },
}
</script>

<style lang="scss">
.grid {
  &__container {
    min-height: 3rem;
    color: $white;
    border-radius: 0.5rem;
  }
}
</style>
